import { useQuery } from '@tanstack/react-query'
import { api } from '../../../shared/api'

// Full mirror of fm.Personen — keeps FM field names (PascalCase) so the
// schema and UI share one vocabulary. Backend returns SELECT *.

export interface Person {
  // Identity
  MainID: number
  PersonalID: number | null
  // Name / gender
  Vorname: string | null
  Nachname: string | null
  Geschlecht: string | null
  // Contact
  eMail: string | null
  Telefonnummer: string | null
  Handy: string | null
  // Adresse
  Strasse: string | null
  PLZ: string | null
  Stadt: string | null
  Bundesland: string | null
  // Stammdaten
  Geburtsdatum: string | null
  Geburtsort: string | null
  Staatsangehoerigkeit: string | null
  Familienstand: string | null
  Religion: string | null
  Kinderanzahl: number | null
  Kinderfreibetrag: number | null
  Elterneigenschaft: string | null
  // Beschäftigung (current)
  Firma: string | null
  Status: string | null
  Schule: string | null
  Berufsbezeichnung: string | null
  Anstellungsart: string | null
  Arbeitszeit: string | null
  ArbeitsTage: string | null
  Woechentlichearbeitszeiten: number | null
  Arbeitszeit_Von: number | null
  Arbeitszeit_Bis: number | null
  ArbeitszeitDifferenz: number | null
  Eintrittsdatum: string | null
  EintrittsdatumInfo: string | null
  Austrittdatum: string | null
  AustrittdatumInfo: string | null
  Probezeit: number | null
  Urlaubsanspruch: number | null
  SommerferienTage: number | null
  Ferienteilnahme: string | null
  istFerienBezahlt: string | null
  // Payroll (current)
  Monatsgehalt: number | null
  Monatsgehaltart: string | null
  StdLohn: number | null
  StdBasiert: string | null
  BruttoZuZahlen: number | null
  Essensgeld: string | null
  // Zukunft
  Zukunftsdaten_Aktualisiert: string | null
  Berufsbezeichnung_Zukunft: string | null
  Anstellungsart_Zukunft: string | null
  Arbeitszeit_Zukunft: string | null
  ArbeitsTage_Zukunft: string | null
  Woechentlichearbeitszeiten_Zukunft: number | null
  Arbeitszeit_Von_Zukunft: number | null
  Arbeitszeit_Bis_Zukunft: number | null
  ArbeitszeitDifferenz_Zukunft: number | null
  Eintrittsdatum_Zukunft: string | null
  Austrittdatum_Zukunft: string | null
  Urlaubsanspruch_Zukunft: number | null
  SommerferienTage_Zukunft: number | null
  Ferienteilnahme_Zukunft: string | null
  Monatsgehalt_Zukunft: number | null
  Monatsgehaltart_Zukunft: string | null
  StdLohn_Zukunft: number | null
  StdBasiert_Zukunft: string | null
  Essensgeld_Zukunft: string | null
  Arbeitsamt_Zukunft: string | null
  // Identification
  ChipID: string | null
  Proficard: string | null
  Kiosk_Benutzername: string | null
  // Tax / SV
  Steueridentifikationsnummer: string | null
  Steuerklasse: number | null
  SteuerJahr: number | null
  SteuerMonat: number | null
  Kirchensteuer: string | null
  Sozialversicherungsnummer: string | null
  Krankenkasse: string | null
  Rentenversicherungsbefreiung: string | null
  // Bank
  IBAN: string | null
  Bankverbindung: string | null
  // Arbeitserlaubnis
  Arbeitsamt: string | null
  ArbeitserlaubnisBis: string | null
  Jobcenter: string | null
  // Führerschein
  Fuehrerschein: string | null
  FuehrerscheinAusstelldatum: string | null
  FuehrerscheinProbezeit: string | null
  // Schwerbehindert
  Schwerbehindert: string | null
  SchwerbehinderungsProzent: number | null
  // Geldvorteile
  Geldvorteil_Sonstiges: string | null
  Geldvorteil_Tankkarte: string | null
  Geldvorteil_Wunschgutschein: string | null
  // Compliance
  Gesundheitszeugnis: string | null
  MasernImpfung: string | null
  Geimpft: string | null
  GeimpftAm: string | null
  Datenschutzerklaerung: string | null
  Einwilligungserklaerung: string | null
  Geburtsurkunde: string | null
  DigitalUnterschrift: string | null
  Betriebliche_Altersversorgung: string | null
  // Verträge
  VertragsdatumVon_Alt: string | null
  VertragsdatumVon_Neu: string | null
  Vertragzurueck_gekommen_Alt: string | null
  Vertragzurueck_gekommen_Neu: string | null
  // Zeiterfassung
  Zeiterfassung: string | null
  Zeiterfassung_Stundenkonto_Teilnahme: string | null
  // Notes
  Aenderungen: string | null
  Internebemerkungen: string | null
  DRUCKEN: string | null
  // Related lookups
  SchulenListe_Stadt: string | null
  SchulenListe_Modifiedby: string | null
  SchulenListe_ModifiedDate: string | null
  // Sync
  SyncedAt: string
}

export function usePersonen() {
  return useQuery({
    queryKey: ['personen'],
    queryFn: () => api.get<Person[]>('/api/personen'),
    staleTime: 5 * 60_000,
  })
}
